jQuery(function ($) {
    if (jQuery('#goUpButton').length !== 0) {
        var articleSelector = '.article-back-to-top',
            offset = document.body.clientHeight / 5,
            duration = 300,
            goUpAppear = false;

        $(window).scroll(function () {
            if (!goUpAppear && $(this).scrollTop() > offset) {
                $(articleSelector).fadeIn(duration);
                trackCTANoInteraction('go_up_appear');
                goUpAppear = true;
            } else if (goUpAppear && $(this).scrollTop() < offset) {
                $(articleSelector).fadeOut(duration);
                goUpAppear = false;
            }
        });

        $(articleSelector).click(function (event) {
            trackCTA('go_up_clicked');
            trackConversion('go_up_clicked');
            event.preventDefault();
            scrollToTop(duration);

            return false;
        });

        // Pure JS function to scroll
        function scrollToTop(scrollDuration) {
            var cosParameter = window.pageYOffset / 2,
                scrollCount = 0,
                oldTimestamp = performance.now();
            function step (newTimestamp) {
                scrollCount += Math.PI / (scrollDuration / (newTimestamp - oldTimestamp));
                if (scrollCount >= Math.PI) window.scrollTo(0, 0);
                if (window.pageYOffset === 0) return;
                window.scrollTo(0, Math.round(cosParameter + cosParameter * Math.cos(scrollCount)));
                oldTimestamp = newTimestamp;
                window.requestAnimationFrame(step);
            }
            window.requestAnimationFrame(step);
        }



    }
});